// @ts-nocheck
/* eslint-disable */
Mapy.TrafficGeometry = (function() {
	// 0 - nejsou, pak 4 urovne flow, 0 nemame data - pruhledne
	const COLORS = ['rgba(0, 0, 0, 0)', '#00d654', '#ffb000', '#ff1300', '#960000'];
	const STYLE = {
		DEFAULT: {
			width: 2,
			opacity: 1,
			outlineColor: "#fff",
			outlineWidth: 4,
			outlineOpacity: 1,
		},
		HIGHWAY: {
			width: 3,
			opacity: 1,
			outlineColor: "#fff",
			outlineWidth: 5,
			outlineOpacity: 1,
		}
	};

	// vraci pocet metru pro gradient na jednu ci druhou stranu od pocatku geometrie dle zoomu, drive bylo natvrdo 20
	function pixelsByZoom(zoom) {
		return Math.min(Math.max((((zoom - 12) * 2) + 10), 10), 20);
	}

	class TrafficGeometry {
		constructor(pois, zoom, wgs84Y) {
			this._pois = pois;
			this._geometries = [];
			this._metersAtZoom = this._countMetersAtZoom(wgs84Y, zoom, pixelsByZoom(zoom));

			// jenom ty co maji geometrie
			let items = this._pois.filter(i => i.geom && i.geom.data);
			items.forEach(item => {
				this._parseItem(item);
			});
		}

		get geometries() {
			return this._geometries;
		}

		/**
		 * Prepocita x pixelu na danem zoomu na metry.
		 *
		 * @param {Number} y WGS84 souradnice y
		 * @param {Number} zoom Dany zoom
		 * @param {Number} pixelsCount Pocet pixelu
		 * @return  {Number}
		 */
		_countMetersAtZoom(y, zoom, pixelsCount) {
			let equatorLength = 2 * Math.PI * 6378137;
			let pxM = equatorLength / (256 * (1 << zoom)) * Math.cos(y / 180 * Math.PI);
			
			return (pxM * pixelsCount);
		}

		/**
		 * Uvnitr jsou SMAP souradnice, kvuli tomu, ze se to vykresluje pak v namespacu smap!
		 *
		 * @param   {Object}  item Data s geometrii
		 */
		_parseItem(item) {
			// preskocime
			if (!item.extend || !item.extend.flow || item.geom.type != "linestring") return;

			let options = Object.assign({}, item.extend.fc >= 1 && item.extend.fc <= 4 ? STYLE.HIGHWAY : STYLE.DEFAULT)
			let flow = item.extend.flow;

			if (flow.length > 1) {
				let coords = SMap.Coords.stringToCoords(item.geom.data[0]);
				let distances = Mapy.Util.IP.countDistances(coords);
				let coordsAndDistances = [];

				for (let i = 0, max = coords.length; i < max; i++) {
					coordsAndDistances.push({
						coord: coords[i],
						distance: distances[i]
					})
				}

				// nove delici body
				let newCoords = [];

				// vytvorime delici body a usecky
				flow.forEach((flowItem, ind) => {
					if (flowItem.i < 0) return;
					if (ind == 0) return;

					let middleDistance = Mapy.Util.IP.dataAtIndex(flowItem.i, coords, distances).distance;
					let leftDistance = Math.max(middleDistance - this._metersAtZoom, 0);
					let rightDistance = middleDistance + this._metersAtZoom;
					let leftCoord = Mapy.Util.IP.getCoordAtDistance(leftDistance, coords, distances).toWGS84();
					let rightCoord = Mapy.Util.IP.getCoordAtDistance(rightDistance, coords, distances).toWGS84();

					newCoords.push({
						coord: SMap.Coords.fromWGS84(leftCoord[0], leftCoord[1]),
						distance: leftDistance,
						type: "left",
						value: flow[ind - 1].l
					});

					newCoords.push({
						coord: SMap.Coords.fromWGS84(rightCoord[0], rightCoord[1]),
						distance: rightDistance,
						type: "right",
						value: flowItem.l
					});
				});

				// nove body vlozime do puvodni geometrie
				while (newCoords.length) {
					coordsAndDistances.push(newCoords.pop());
				}
				// seradime podle vzdalenosti od zacatku po konec
				coordsAndDistances.sort((a, b) => {
					return a.distance - b.distance;
				});

				// mam upravene body a serazene
				let lines = [];
				let lineCoords = [];
				// pocatecni hodnota
				let value = flow[0].l;
				let lastValue = value;

				coordsAndDistances.forEach(item => {
					if (!item.type) {
						lineCoords.push(item.coord);
					} else {
						// ukoncime predeslou caru
						lineCoords.push(item.coord);

						// nova usecka
						let newLine = {
							style: {
								color: COLORS[value]
							},
							// kopie pole
							coords: lineCoords.slice()
						};

						if (item.type == "right") {
							if (lastValue != item.value) {
								let gradientColors = [];

								if (lastValue < item.value) {
									for (let i = lastValue; i <= item.value; i++) {
										gradientColors.push(COLORS[i]);
									}
								}
								else {
									for (let i = lastValue; i >= item.value; i--) {
										gradientColors.push(COLORS[i]);
									}
								}

								newLine.style.gradient = gradientColors;
							}
						}
						else if (item.type == "left") {
							lastValue = value;
						}

						// vlozime
						lines.push(newLine);

						// nastavime novy index
						value = item.value;
						// novy index
						lineCoords.length = 0;
						// novy zacatek
						lineCoords.push(item.coord);
					}
				});

				// konec - zbylo neco? Ulozime si to
				if (lineCoords.length) {
					lines.push({
						style: {
							color: COLORS[value],
						},
						coords: lineCoords.slice()
					});
					lineCoords.length = 0;
				}

				// jednotlive lajny budou jednotlive geometrie
				lines.forEach(line => {
					// upravy pro gradienty a orezavani car
					if (line.style.gradient) {
						let gradLen = line.style.gradient.length;
						// zacatek je prazdny
						let gradStart = line.style.gradient[0] == COLORS[0];
						// konec je prazdny
						let gradEnd = line.style.gradient[gradLen - 1] == COLORS[0];

						if (gradStart || gradEnd) {
							let searchInd = Math.floor(line.coords.length / gradLen);
							// zahodime levou/pravou cast souradnic u gradientu
							line.coords = line.coords.filter((i, ind) => {
								if (gradStart) return (ind >= searchInd);
								else return (ind <= searchInd);
							});

							// odebereme prazdny gradient
							if (gradStart) {
								line.style.gradient.shift();
							}
							else {
								line.style.gradient.pop();
							}

							// zbyl jenom jeden? Nastavime ho jako barvu
							if (line.style.gradient.length == 1) {
								line.style.color = line.style.gradient[0];
								delete line.style.gradient;
							}
						}
					}
					
					this._geometries.push({
						coords: line.coords,
						style: Object.assign({}, options, line.style)
					});
				});
			}
			else {
				this._geometries.push({
					coords: SMap.Coords.stringToCoords(item.geom.data[0]),
					style: Object.assign({}, options, {
						color: COLORS[flow[0].l]
					})
				});
			}
		}
	}

	return TrafficGeometry;
})();
